import { useLocation, useNavigate } from 'react-router-dom';
import { useCallback } from 'react';

export const useLanguageURL = () => {
  const location = useLocation();
  const navigate = useNavigate();

  // Get current language from URL - use current location.search directly
  const getLanguageFromURL = useCallback(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const langParam = urlParams.get('lang');
    return langParam === 'ru' || langParam === 'en' ? langParam : 'ru';
  }, []); // No dependencies to avoid re-creation

  // Set language in URL
  const setLanguageInURL = useCallback((language) => {
    const urlParams = new URLSearchParams(window.location.search);
    urlParams.set('lang', language);
    const newURL = `${window.location.pathname}?${urlParams.toString()}`;
    navigate(newURL, { replace: true });
  }, [navigate]); // Only depend on navigate

  // Check if URL has language parameter
  const hasLanguageParam = useCallback(() => {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.has('lang');
  }, []); // No dependencies

  // Get all URL parameters except language
  const getOtherParams = useCallback(() => {
    const urlParams = new URLSearchParams(window.location.search);
    urlParams.delete('lang');
    return urlParams.toString();
  }, []); // No dependencies

  // Create URL with language parameter
  const createURLWithLanguage = useCallback((language, path = null) => {
    const currentPath = path || window.location.pathname;
    const otherParams = getOtherParams();
    const params = otherParams ? `?${otherParams}&lang=${language}` : `?lang=${language}`;
    return `${currentPath}${params}`;
  }, [getOtherParams]);

  return {
    getLanguageFromURL,
    setLanguageInURL,
    hasLanguageParam,
    getOtherParams,
    createURLWithLanguage,
    currentURL: location.pathname + location.search
  };
}; 